import mainPhoto from "../assets/png/domi_igla.png";

export const headerData = {
  name: "Dominika Mróz",
  title: "Fizjoterapeuta i Trener",
  desciption:
    "W dzisiejszym świecie szybkich rozwiązań indywidualne podejście do potrzeb jest kluczowe. Każdy ma unikalne wymagania i możliwości. Moja praca to pomoc w radzeniu sobie z bólem, kontuzjami oraz dbanie o zdrowie i sprawność, aby odzyskać kontrolę nad życiem. Pokażę Ci, jak to osiągnąć.",
  image: mainPhoto,
  registrationHref:
    "https://rejestracja.medfile.pl/register/catalog/?uuid=9a9c2846-8265-3d17-446d-615f8fec2249",
};
